import { useState, useEffect } from "react";
import { intlShape } from "../shapes";

import Markdown from "./Markdown";
import { withIntl } from "../wrappers";
import { apiShape, notifierShape, withApi, withNotifier } from "../context";
import { isSomething } from "../utils";

type Props = {
  intl: intlShape;
  api: apiShape;
  notifier: notifierShape;
};

export function Notification({ api, intl, notifier }: Props) {
  const [notification, setNotification] = useState();

  useEffect(() => {
    async function loadNotification() {
      if (!notification) {
        try {
          const response = await api.get("/users/current/notifications", {
            per_page: 1,
          });

          if (response?.notifications && response?.notifications.length > 0) {
            setNotification({
              // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: any; content: any; }' is n... Remove this comment to see the full error message
              id: response?.notifications[0].id,
              content: response?.notifications[0].content,
            });
          }
        } catch (error) {
          notifier.showError(api.translateError(error));
        }
      }
    }
    loadNotification();
  }, [notification]);

  const hide = async () => {
    // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type 'undefined'.
    const { id } = notification;
    if (isSomething(id)) {
      try {
        await api.delete(`/users/current/notifications/${id}`);
        setNotification(undefined);
      } catch (error) {
        notifier.showError(api.translateError(error));
      }
    }
  };

  return (notification as $TSFixMe)?.content ? (
    <div className="notification" id="notification-message">
      <Markdown content={(notification as $TSFixMe).content} />
      <button
        type="button"
        className="btn hide-button"
        id="notification-hide-button"
        onClick={hide}
      >
        {intl.formatMessage({ id: "button.hide" })}
      </button>
    </div>
  ) : null;
}

export default withIntl(withApi(withNotifier(Notification)));
